import { css, styled } from "@mui/material";
import { Box, colors } from "@procore/core-react";

export const VisibilityButton = styled(Box)<{ disabled?: boolean }>(
    ({ disabled }) => css`
        cursor: ${disabled ? "not-allowed" : "pointer"};
        display: flex;
        align-items: center;
        padding: 4px;
        border-radius: 4px;
        opacity: ${disabled ? 0.4 : 1};

        &:hover {
            background-color: ${disabled ? "transparent" : colors.gray90};
        }
    `,
);
